import { render, staticRenderFns } from "./HomeActivitiesLinks.vue?vue&type=template&id=3c18a94c&scoped=true"
import script from "./HomeActivitiesLinks.vue?vue&type=script&lang=js"
export * from "./HomeActivitiesLinks.vue?vue&type=script&lang=js"
import style0 from "./HomeActivitiesLinks.vue?vue&type=style&index=0&id=3c18a94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18a94c",
  null
  
)

/* custom blocks */
import block0 from "./HomeActivitiesLinks.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports